import Model from "@tripian/model";

/**
 * TourInfo sayfasının (`TourInfo.tsx`) detay bileşeni bulunan provider'lar.
 * tour-api bunların dışında da ürün döndürüyor (ör. Civitatis, GoCity); onlar için
 * iç detay sayfası olmadığından ürünün kendi url'i yeni sekmede açılır.
 */
export const TOUR_INFO_PROVIDER_IDS: Model.PROVIDER_ID[] = [
  Model.PROVIDER_ID.GYG,
  Model.PROVIDER_ID.VIATOR,
  Model.PROVIDER_ID.BOOK_BARBADOS,
  Model.PROVIDER_ID.REZDY,
  Model.PROVIDER_ID.TORISTY,
  Model.PROVIDER_ID.VICTORY,
  Model.PROVIDER_ID.LIVN,
];

export const isTourInfoSupported = (providerId: number): boolean =>
  TOUR_INFO_PROVIDER_IDS.includes(providerId as Model.PROVIDER_ID);

export interface TourInfoSearchParams {
  cityId?: string | number;
  cityName?: string;
  startDate?: string;
  endDate?: string;
  adults?: string | number;
  children?: string | number;
}

/** Arama bağlamını detay sayfasına taşıyan query string ("" ya da "?a=b" döner). */
export const buildTourInfoSearch = ({
  cityId,
  cityName,
  startDate,
  endDate,
  adults,
  children,
}: TourInfoSearchParams): string => {
  const search = new URLSearchParams();
  if (cityId) search.set("city_id", String(cityId));
  if (cityName) search.set("city_name", cityName);
  if (startDate) search.set("start_date", startDate);
  if (endDate) search.set("end_date", endDate);
  if (adults) search.set("adults", String(adults));
  if (children) search.set("children", String(children));

  const asString = search.toString();
  return asString ? `?${asString}` : "";
};
